export const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const modalContainer = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
};
export const buttonModal = {
  display: "flex",
  alignContent: "flex-end",
  justifyContent: "flex-end",
};

export const styleContainer = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  backgroundColor: "white",
  marginLeft: { xs: "10px", md: "70px" },
  marginRight: { xs: "10px", md: "70px" },
  maxHeight: { xs: "94vh", md: "150px" },
  alignContent: "center",
  alignItems: "center",
  borderRadius: "30px",
  marginTop: "30px",
};
export const cardContainer = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const cardMedia = {
  height: { xs: 50, md: 120 },
  width: { xs: 90, sm: 150, md: 180, lg: 300 },
  padding: { xs: 1.5, md: 1 },
  mr: -1.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const buttonMedia = {
  padding: 0,
  height: { xs: 80, md: 120 },
  width: { xs: 160, md: 220 },
};

export const containerDatos = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
  alignContent: "center",
  width: "100%",
  height: "50%",
  marginBottom: { xs: 1, sm: 1, md: "none" },
};

export const containerDatosMobile = {
  display: { xs: "flex", sm: "none" },
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
  alignContent: "center",
  width: "100%",
  height: "50%",
  marginBottom: { xs: 1, sm: 1, md: "none" },
};

export const priceStyle = {
  margin: "0.5vh",
  fontSize: { xs: "14px", md: "18px", lg: "20px" },
  textAlign: "center",
  marginLeft: { xs: "3vw", sm: "0vw", md: "0vw" },
  marginRight: { xs: "3vw", sm: "0vw" },
};

export const boxPriceMobile = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const boxPriceFullScreen = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "100%",
};
export const styleButton = {
  marginLeft: 1,
  marginRight: 1,
  border: 1,
  borderColor: "white",
  color: "white",
  marginBottom: 1.5,
  maxHeight: { xs: "35px" },
};
export const containerStyle = {
  display: "flex",
  alignContent: "center",
  justifyContent: "center",
  flexDirection: "column",
  paddingBottom: "40px",
};
export const cardStyle = {
  marginTop: "0px",
  paddingTop: { xs: 1, md: "px" },
  width: { xs: "100%" },
  maxHeight: { xs: "10%", md: "100%" },
  backgroundColor: "#31559f",
  display: "flex",
  flexDirection: { xs: "row" },
  overflowX: { xs: "auto", md: "hidden" },
  maxWidth: { xs: "100%" },
  whiteSpace: { xs: "nowrap" },
  marginBottom: -2,
};
export const textFieldStyle = {
  marginLeft: 2,
  border: 1,
  borderColor: "white",
  color: "white",
  marginBottom: 1.5,
  borderRadius: 2,
  display: { xs: "none" },
};
